import { connect } from 'react-redux'

import { selectFoundPet } from 'UserApp/store/user/selectors'
import FoundPetAlert from 'UserApp/components/FoundPetAlert'

export default connect((state) => ({
  foundPet: selectFoundPet(state),
}))(FoundPetAlert)
